import React, { useState } from 'react';
import ItemData from '../Model/items.json';

function ProductCard({ image, title, onClick }) {
  return (
    <div
      className="w-full bg-white border border-gray-200 rounded-lg shadow-md cursor-pointer"
      onClick={onClick}
    >
      <div>
        <img className="p-8 rounded-t-lg" src={image} alt="product" />
      </div>
      <div className="px-5 pb-5">
        <h5 className="text-xl font-semibold tracking-tight text-center text-gray-900">{title}</h5>
      </div>
    </div>
  );
}

function ItemList() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);

  const products = ItemData.products;

  const openModal = (product) => {
    setModalContent(product);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalContent(null);
  };

  return (
    <div className="py-8 bg-white bg-no-repeat bg-cover">
      <div className="grid max-w-screen-lg grid-cols-2 gap-6 px-5 mx-auto sm:grid-cols-2 lg:grid-cols-4">
        {products.map((product, index) => (
          <ProductCard key={index} {...product} onClick={() => openModal(product)} />
        ))}
      </div>
      {modalOpen && modalContent && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="relative w-[500px] h-[500px] p-8 bg-white rounded-lg shadow-lg">
            <button onClick={closeModal} className="absolute text-2xl font-bold top-2 right-2">&times;</button>
            <img src={modalContent.image} alt={modalContent.title} className="object-cover w-full h-full" />
          </div>
        </div>
      )}
    </div>
  );
}

export default ItemList;
